import Criteria from './criteria';
import Connect from './criteria-connect';
import Header from './criteria-header';
import Rule from './criteria-rule';
import * as Rules from './rules';

//
// Attach children to the main Component for availability without ES6 imports.
//
Criteria.Connect = Connect;
Criteria.Header = Header;
Criteria.Rules = Rules;
Criteria.Rule = Rule;

//
// Export the Class and related children.
//
export {
  Criteria,
  Rule,
  Header,
  Connect,
  Rules
};

export default Criteria;



// WEBPACK FOOTER //
// ./node_modules/@ux/criteria/index.js